import React, { memo, useState } from 'react';
import { Col, InputGroup, FormGroup, Label, Input } from 'reactstrap';

import { showMsg } from '../../services/library';
import AuthService from '../../services/authService';
import CustomModal from '../../components/GeneralForm/CustomModal';

const PasswordField = ({
  label,
  name,
  value,
  showPassword,
  onChange,
  onFocus,
  onBlur,
  toggleShowPassword
}) => {
  return (
    <FormGroup row>
      <Label for={name} sm={4} className="text-right">
        <span className="text-danger">*</span>
        {label}
      </Label>
      <Col sm={8}>
        <InputGroup>
          <Input
            type={showPassword ? 'text' : 'password'}
            name={name}
            id={name}
            readOnly
            placeholder={`Enter ${label}`}
            autoComplete="off"
            value={value}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
          />
          <div className="input-group-append" style={{ cursor: 'pointer' }} onClick={toggleShowPassword}>
            <span className="input-group-text">
              <i
                className={`fa fa-fw  ${showPassword ? 'fa-eye text-white' : 'fa-eye-slash'}`}
                aria-hidden="true"
              />
            </span>
          </div>
        </InputGroup>
      </Col>
    </FormGroup>
  );
};

const ChangePasswordModal = props => {
  const [currentpass, setCurrentPass] = useState('');
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [newpass, setNewPass] = useState('');
  const [showNewPass, setShowNewPass] = useState(false);
  const [confirmpass, setConfirmPass] = useState('');
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const handleCurrentPassChange = e => setCurrentPass(e.target.value);
  const handleNewPassChange = e => setNewPass(e.target.value);
  const handleConfirmPassChange = e => setConfirmPass(e.target.value);

  const handleFieldFocus = e => (e.target.readOnly = false);
  const handleFieldBlur = e => (e.target.readOnly = true);

  const toggleShowCurrentPass = () => setShowCurrentPass(prev => !prev);
  const toggleShowNewPass = () => setShowNewPass(prev => !prev);
  const toggleShowConfirmPass = () => setShowConfirmPass(prev => !prev);

  const validate = () => {
    const trimmedCurrentPass = currentpass?.trim();
    const trimmedNewPass = newpass?.trim();
    const trimmedConfirmPass = confirmpass?.trim();
    const errMSG = [];

    if (!trimmedCurrentPass) {
      errMSG.push('Current password is required.');
    }
    if (!trimmedNewPass) {
      errMSG.push('New password is required.');
    }
    if (!trimmedConfirmPass) {
      errMSG.push('Confirm password is required.');
    }
    if (trimmedCurrentPass === trimmedNewPass) {
      errMSG.push('Current password and new password are same.');
    }
    if (trimmedNewPass !== trimmedConfirmPass) {
      errMSG.push('Password does not match.');
    }

    if (errMSG.length > 0) {
      showMsg(errMSG, 'error');
      return false;
    }
    return true;
  };

  const editPassword = data => {
    props.handleFullLayoutLoader(true);
    AuthService.changePassword(data)
      .then(response => {
        if (response.status) {
          showMsg(response.message, 'success');
          props.modalTrigger();
        } else {
          return showMsg(response.errors, 'error');
        }
      })
      .catch(error => {
        showMsg(error, 'error');
      })
      .finally(() => {
        props.handleFullLayoutLoader(false);
      });
  };

  const submittedData = () => {
    if (validate()) {
      editPassword({
        current_pass: currentpass,
        new_pass: newpass
      });
    }
  };

  return (
    <CustomModal
      isOpen={props.changePasswordToggle}
      closeClick={props.modalTrigger}
      modalSize="lg"
      saveClick={submittedData}
      modalTitle="Change Password"
      modalBackDrop="static"
    >
      <div className="d-flex mb-4">
        <span className="ml-auto align-self-start small">
          <span className="text-danger">*</span>
          Required Field
        </span>
      </div>
      <PasswordField
        label="Current Password"
        name="currentpass"
        value={currentpass}
        showPassword={showCurrentPass}
        onChange={handleCurrentPassChange}
        onFocus={handleFieldFocus}
        onBlur={handleFieldBlur}
        toggleShowPassword={toggleShowCurrentPass}
        {...props}
      />
      <PasswordField
        label="New Password"
        name="newpass"
        value={newpass}
        showPassword={showNewPass}
        onChange={handleNewPassChange}
        onFocus={handleFieldFocus}
        onBlur={handleFieldBlur}
        toggleShowPassword={toggleShowNewPass}
        {...props}
      />
      <PasswordField
        label="Confirm Password"
        name="confirmpass"
        value={confirmpass}
        showPassword={showConfirmPass}
        onChange={handleConfirmPassChange}
        onFocus={handleFieldFocus}
        onBlur={handleFieldBlur}
        toggleShowPassword={toggleShowConfirmPass}
        {...props}
      />
    </CustomModal>
  );
};

ChangePasswordModal.displayName = 'ChangePasswordModal';
export default memo(ChangePasswordModal);
